var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25,
    r: 25,
    fill: "#E53E3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0603 19.061C34.6463 18.4755 34.6466 17.5257 34.061 16.9397C33.4755 16.3537 32.5257 16.3534 31.9397 16.939L26.0285 22.846L20.1264 16.9397C19.5408 16.3537 18.5911 16.3534 18.0051 16.939C17.4191 17.5245 17.4187 18.4743 18.0043 19.0603L23.9064 24.9666L18.0071 30.8617C17.4211 31.4473 17.4207 32.3971 18.0063 32.983C18.5919 33.569 19.5416 33.5694 20.1276 32.9838L26.027 27.0886L31.9271 32.9929C32.5126 33.5789 33.4624 33.5793 34.0484 32.9937C34.6344 32.4081 34.6347 31.4584 34.0491 30.8724L28.149 24.9681L34.0603 19.061Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedStatus);
export default __webpack_public_path__ + "static/media/RejectedStatus.aba4811cbfcdd2c7d16fe54d9034ef2e.svg";
export { ForwardRef as ReactComponent };